var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25527 12.1043H6.74486C6.60391 12.1043 6.48965 11.9901 6.48965 11.8491V3.59568L4.2234 5.86704C4.17548 5.91535 4.11025 5.94253 4.0422 5.94253C3.97415 5.94253 3.90892 5.91535 3.861 5.86704L3.50371 5.50464C3.4554 5.45672 3.42822 5.39149 3.42822 5.32344C3.42822 5.2554 3.4554 5.19017 3.50371 5.14225L6.63257 2.00829C6.70429 1.93648 6.80159 1.89609 6.90309 1.896H7.09705C7.19832 1.89717 7.29523 1.9374 7.36757 2.00829L10.4964 5.14225C10.5447 5.19017 10.5719 5.2554 10.5719 5.32344C10.5719 5.39149 10.5447 5.45672 10.4964 5.50464L10.134 5.86704C10.087 5.91505 10.0226 5.94211 9.95538 5.94211C9.88816 5.94211 9.82377 5.91505 9.77673 5.86704L7.51048 3.59568V11.8491C7.51048 11.9901 7.39622 12.1043 7.25527 12.1043Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.c5a6b783fc2a3458cebba8ab28ce759c.svg";
export { ForwardRef as ReactComponent };